// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__2TR-Y","item":"main_item__2M-av","active":"main_active__2RfLb"};